import { t } from "@/i18n-js/instance";
import { Form } from "@/react/components/shared/uikit/Form";
import { EditorCollapsable } from "@circle-react-shared/BuilderUI/Editor/EditorCollapsable";
import { AlignmentField } from "@circle-react-shared/BuilderUI/Editor/fields/AlignmentField";
import { SliderField } from "@circle-react-shared/BuilderUI/Editor/fields/SliderField";
import {
  FONT_STYLE_OPTIONS,
  EMAIL_TEXT_FONT_WEIGHT_OPTIONS as FONT_WEIGHT_OPTIONS,
  TEXT_ALIGN_OPTIONS,
  TEXT_DECORATION_OPTIONS,
  TEXT_TRANSFORM_OPTIONS,
} from "@circle-react-shared/Emails/VisualEmailBuilder/Themes/Tokens/constants";
import { useEmailCustomColors } from "@circle-react-shared/Emails/VisualEmailBuilder/Themes/hooks/useEmailCustomColors";

const generateFormItemName = (name: string) => {
  const nameParts = name.split(".");
  return ["styles", ...nameParts].join(".");
};

export const Text = () => {
  const {
    flattenedCssVariables,
    themeColors,
    customColors,
    handleAddCustomColor,
  } = useEmailCustomColors();
  const labelClassName = "!font-normal text-xs";

  return (
    <EditorCollapsable
      title={t("builder_ui.prop_type.styles.text")}
      defaultOpen
    >
      <div className="px-6 py-5">
        <Form.Item
          name={generateFormItemName("color")}
          label={t("builder_ui.prop_type.styles.color")}
          hideDescription
          hideBorder
          className="!flex !w-full !items-center !justify-between !p-0"
          labelClassName={labelClassName}
        >
          <Form.ColorPickerV2
            name={generateFormItemName("color")}
            cssVariables={flattenedCssVariables}
            shouldResolveCssVariable
            shouldRenderThemeColors
            shouldShowAlpha={false}
            themeColors={themeColors}
            customColors={customColors}
            onAddCustomColor={handleAddCustomColor}
          />
        </Form.Item>
        <Form.Item
          name={generateFormItemName("textTransform")}
          label={t("builder_ui.prop_type.styles.text_transform")}
          hideDescription
          hideBorder
          labelClassName={labelClassName}
        >
          <Form.SelectNative
            name={generateFormItemName("textTransform")}
            options={TEXT_TRANSFORM_OPTIONS}
          />
        </Form.Item>

        <Form.Item
          name={generateFormItemName("fontStyle")}
          label={t("builder_ui.prop_type.styles.font_style")}
          hideDescription
          hideBorder
          labelClassName={labelClassName}
        >
          <Form.SelectNative
            name={generateFormItemName("fontStyle")}
            options={FONT_STYLE_OPTIONS}
          />
        </Form.Item>
        <Form.Item
          name={generateFormItemName("fontWeight")}
          label={t("builder_ui.prop_type.styles.font_weight")}
          hideDescription
          hideBorder
          labelClassName={labelClassName}
        >
          <Form.SelectNative
            name={generateFormItemName("fontWeight")}
            options={FONT_WEIGHT_OPTIONS}
          />
        </Form.Item>
        <div className="mt-2">
          <SliderField
            name={generateFormItemName("fontSize")}
            label={t("builder_ui.prop_type.styles.font_size")}
            units={["px"]}
            defaultUnit="px"
            step={1}
            min={8}
            max={100}
          />
        </div>
        <Form.Item
          name={generateFormItemName("lineHeight")}
          label={t("builder_ui.prop_type.styles.line_height")}
          hideDescription
          hideBorder
          labelClassName={labelClassName}
        >
          <Form.Input
            name={generateFormItemName("lineHeight")}
            type="number"
            min={0}
            max={5}
            step={0.1}
          />
        </Form.Item>

        <Form.Item
          name={generateFormItemName("textDecoration")}
          label={t("builder_ui.prop_type.styles.text_decoration")}
          hideDescription
          hideBorder
          labelClassName={labelClassName}
        >
          <Form.SelectNative
            name={generateFormItemName("textDecoration")}
            options={TEXT_DECORATION_OPTIONS}
          />
        </Form.Item>

        <div className="mt-5">
          <AlignmentField
            label={t("builder_ui.prop_type.styles.text_align")}
            name={generateFormItemName("textAlign")}
            options={TEXT_ALIGN_OPTIONS}
          />
        </div>
      </div>
    </EditorCollapsable>
  );
};
